import { registerBlockType } from '@wordpress/blocks';

import './style.css';

import metadata from './block.json';
import Edit from './edit';
import save from './save';
import deprecated from './deprecated';

import { starEnvelopeIcon } from '../../img/icons';

registerBlockType( metadata.name, {
  icon: starEnvelopeIcon,
  edit: Edit,
  save,
  deprecated
});
